import * as R from 'ramda';
import reducer from './reducer';
import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import schemas from './schemas';

export const root = R.path([reducer.name]);

export const selectResult = R.pipe(root, R.prop('result'));
export const selectList = R.pipe(root, R.prop('list'));

export const selectQuestions = createSelector(
  selectResult,
  selectList,
  (result, list) => denormalize(
    { questions: result },
    { questions: [schemas.questionSchema] },
    { questions: list }
  ).questions,
);

const selectRouteId = (state, props) => R.path(['match', 'params', 'id'], props);

export const selectQuestion = createSelector(
  selectList,
  selectRouteId,
  (list, id) => {
    if (!list) {
      return;
    }

    const question = R.prop(id, list);

    if (!question) {
      return false;
    }

    return question;
  },
);

export default {
  selectQuestions,
  selectQuestion,
  selectList,
};
